import React, { Component } from 'react';
import axios from 'axios'
import { Container } from 'semantic-ui-react'
import { base, ref, firebaseAuth, serverIp, } from '../../../../config/constants.js'
import { TopMenu, OrderCardsTable } from '../DashboardParts';
import * as UiConsts from '../../../../config/UiConstants'
import { checkAdminEmail } from '../../newDashboard/algoliaDashboard/AlgoliaMiscUtils';


export class ViewServerResultsGet extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serverUrl: '',
            loading: true,
            allOrders: []
        }
    }

    componentDidMount() {
        console.log("clx0 +++++ componentDidMount");
        console.log("clx01 - this.props.match.params.serverurl:"+this.props.match.params.serverurl);
        this.setState({
            serverUrl: this.props.match.params.serverurl
        }, this.callServerApi())


        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })
            

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));
        this.setState({
            algoliaUser: returnObject.algoliaUser,
            isAdmin: returnObject.isAdmin,
        })
    }

    callServerApi = () => {
        console.log("clx1 +++++:  callServerApi serverUrl:" + this.props.match.params.serverurl);
        console.log("clx12 callServerApi combined:" + serverIp + this.state.serverUrl);

     //   var str = this.state.serverUrl;
        var finalString = this.props.match.params.serverurl.replace("_", "/");
        finalString = finalString.replace("_", "/");
        console.log("clx13 final string:"+serverIp + finalString);

        axios.get(serverIp + finalString)
            .then((response) => {
                console.log(response.data);

                this.setState({
                    allOrders: response.data.firebaseOrders,
                    loading: false
                })
            })
            .catch((error) => {
                console.log(error);
            });
    }

    render() {
        return (

            this.state.loading ? <UiConsts.LoadingComponent /> :

                <Container>
                    <TopMenu />
                    <h3>{this.state.allOrders.length} ORDERS</h3>
                    <OrderCardsTable
                        user={this.state.user}
                        orders={this.state.allOrders} />
                </Container>

        )
    }
}

export default ViewServerResultsGet;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/ViewServerResults/ViewServerResultsGet.js